import supabaseClient from "../supabase-client/api/supabaseClient";

export const supabase = supabaseClient;
